import React from "react";
import "./components/css/style.css";
import AppRoute from "./AppRoute";
import AppWrapper from "./AppWrapper";

function App() {
  return (
    <AppWrapper>
      <AppRoute />
    </AppWrapper>
  );
}

export default App;
